"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = void 0;
exports.auth = {
    login: {
        buttons: {
            clickHere: "click here",
        },
        errors: {
            resendTemporaryPassword: "This password has expired. A new temporary password has been sent to your email address.",
            ssoRequired: "Your user must sign in via SSO",
            noSsoOptions: "Your user does not have any SSO options",
        },
    },
    form: {
        label: {
            emailAddress: "$t(common:emailAddress)",
            password: "$t(common:password)",
            passwordConfirmation: "Confirm Password",
            newPassword: "New Password",
            oldPassword: "Temporary Password",
        },
        placeholder: {
            emailAddress: "$t(common:emailAddress)",
            password: "$t(common:password)",
            passwordConfirmation: "$t(auth:form.label.passwordConfirmation)",
            newPassword: "Your new password",
            oldPassword: "Your temporary password",
        },
        errors: {
            invalidEmail: "This email is invalid",
            requiredField: "This field is required",
            matchField: "Passwords must match",
            invalidDate: "This is an invalid date format",
        },
        buttons: {
            login: "Sign in",
            forgot: "$t(auth:title.forgot)",
            save: "Save Password",
            next: "Next",
            back: "Back",
            signInUsing: "Sign in using",
        },
        links: {
            forgotPassword: "Forgot password?",
            back: "$t(common:back)",
        },
    },
    title: {
        login: "Hey!",
        forgot: "Reset Password",
        reset: "New Password",
        welcome: "Welcome!",
    },
    description: {
        login: "Sign into your account",
        sso: "SSO sign In",
        forgot: "Enter your email address and click the ‘reset password’ button and we’ll send you a link to create a new password..",
        reset: "Create a new password. Your password must be at least 8 characters in length.",
        welcome: "Set a strong password for your new account. Minimum 7 characters: 1 special character, number and uppercase/lowercase letter.",
        minimumLength: "Minimum length: ",
        uppercaseRequired: "One Uppercase character is required",
        numberRequired: "One numerical character is required",
        symbolRequired: "One symbol character is required",
    },
    strapline: {
        start: "We are the",
        middle: "U.K's largest Man & Van",
        end: "clearance company.",
    },
    modal: {
        headings: {
            verify: "Password verification code sent!",
        },
        buttons: {
            signIn: "Sign in",
        },
    },
};
